import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type ToggleOption = {
  value: string;
  label?: string;
  [key: string]: unknown;
};

type Props = {
  name: string;
  label?: string;
  options: ToggleOption[];
  disabled?: boolean;
};

const VNToggle = ({ name, label = 'label', options, disabled }: Props) => {
  const { control } = useFormContext();

  return (
    <div className="vn-toggle">
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ToggleButtonGroup {...field} exclusive disabled={disabled}>
            {options.map((opt) => (
              <ToggleButton key={opt.value} value={opt.value}>
                {opt[label] as React.ReactNode}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        )}
      />
    </div>
  );
};

export default VNToggle;
